export enum WellKnownAppointmentTypes {
  single = 1,
  joint = 2,
  jointAndSeveral = 3,
}
